import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const storedToken = localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
  const accessToken = JSON.parse(storedToken);
  const [token, setToken] = useState(accessToken || "");

  const login = (tokenVal) => {
    setToken(tokenVal);
    localStorage.setItem("access_token", JSON.stringify(tokenVal));
  };
  const tempLogin = (tokenVal) => {
    setToken(tokenVal);
    sessionStorage.setItem("access_token", JSON.stringify(tokenVal));
  };

  const logout = () => {
    setToken("");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };
  const isAuthenticated = !!token;
  return (
    <AuthContext.Provider value={{ token, login, tempLogin, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};
